import { useMemo } from "react";
import useGroupsContext from "hooks/useGroupsContext";
import { CombinedAthletesAndGroups } from "types";
import { EntityType } from "types/entity";
import difference from "lodash/difference";
import { useArchivedAthletes } from "providers/ArchivedAthletesProvider";
import useAthleteStore from "providers/AthletesProvider/useAthleteStore";
import { useTranslation } from "react-i18next";

function useCombinedAthletesAndGroups(): CombinedAthletesAndGroups {
  const athletes = useAthleteStore();
  const [groups] = useGroupsContext();
  const archivedAthleteIds = useArchivedAthletes(true);
  const { t } = useTranslation();

  const athletesWithType = useMemo(
    () =>
      athletes.map((athlete) => ({
        ...athlete,
        typeLabel: t("global.athlete_label_plural"),
        type: EntityType.ATHLETE as const,
      })),
    [t, athletes]
  );
  const groupsWithType = useMemo(
    () =>
      groups.map((group) => ({
        ...group,
        athleteIds: difference(group.athleteIds, archivedAthleteIds),
        typeLabel: t("global.groups_label"),
        type: EntityType.GROUP as const,
      })),
    [t, archivedAthleteIds, groups]
  );

  return useMemo(() => {
    return [...athletesWithType, ...groupsWithType];
  }, [athletesWithType, groupsWithType]);
}
export default useCombinedAthletesAndGroups;
